// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1a8Am","footer":"ModalCreateQualiphyProcedure_footer__pZUI7","additionData":"ModalCreateQualiphyProcedure_additionData__2U3dj"};